import type { ReactNode } from 'react'
import { cn } from '@shared/ui/lib/utils'
import '../profile-layout.css'

export function ProfileLegacySurface({
  children,
  className,
  padded = true,
}: {
  readonly children: ReactNode
  readonly className?: string
  readonly padded?: boolean
}) {
  return (
    <section className={cn('profileSurface', !padded && 'profileSurfaceFlush', className)}>
      {children}
    </section>
  )
}
